import { commonLang } from '@umu/ukit-lang';
import './pcAlertDialog.scss';
import React, { useState } from 'react';
import { removeElementsByClass } from '../../@utils';
import { If, Button } from 'common/src/components';

export interface IProps {
    closeDialog: () => void;
    content: string | JSX.Element;
    title?: string;
    btnText?: string;
}
export function PcAlertDialog(props: IProps) {
    const { content, title, btnText } = props;
    const [isShow, setIsShow] = useState(true);
    const submit = () => {
        props.closeDialog();
        setIsShow(false);
        removeElementsByClass('.dialog-mask');
    };
    return (
        <If condition={isShow}>
            <div>
                <If condition={!!title}>
                    <div className="title">
                        <div>{title}</div>
                    </div>
                </If>
                <div className="pc-alert-dialog">
                    <If condition={!!content}>
                        <div className="body">
                            <div>{content}</div>
                        </div>
                    </If>
                    <div className="footer">
                        <div className="btn-1">
                            <Button className="sub-alias-plain" type="optional" onClick={submit}>
                                {btnText || commonLang('知道了')}
                            </Button>
                        </div>
                    </div>
                </div>
            </div>
        </If>
    );
}
